module.exports = __webpack_public_path__ + "static/media/gm.eab02478.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gm.svg
// module id = 2101
// module chunks = 0